// components/legal/PolicyHeroBit.jsx
import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';

const PolicyHeroBit = ({ title, description }) => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });

    return (
        <section ref={ref} className="py-20 bg-nude-beige">
            <div className="container mx-auto px-6 lg:px-12">
                <motion.div
                    initial={{ y: 40, opacity: 0 }}
                    animate={isInView ? { y: 0, opacity: 1 } : {}}
                    transition={{ duration: 1 }}
                    className="max-w-4xl mx-auto text-center"
                >
                    <h1 className="font-playfair text-4xl md:text-6xl text-charcoal mb-6">
                        {title}
                    </h1>
                    {description && (
                        <p className="font-poppins text-xl text-charcoal/70">
                            {description}
                        </p>
                    )}
                </motion.div>
            </div>
        </section>
    );
};

export default PolicyHeroBit;